import { render, staticRenderFns } from "./NavActions.vue?vue&type=template&id=15ffaaa4&scoped=true&"
import script from "./NavActions.vue?vue&type=script&lang=js&"
export * from "./NavActions.vue?vue&type=script&lang=js&"
import style0 from "./NavActions.vue?vue&type=style&index=0&id=15ffaaa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ffaaa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
